import { jsx, jsxs } from "react/jsx-runtime";
import { createContext, forwardRef, useContext, useLayoutEffect, useState, useMemo } from "react";
import * as RadixTooltip from "@radix-ui/react-tooltip";
import { DEFAULT_PORTAL_ID } from "../../constants/config.js";
import { cn as clsx } from "../../helpers/react.js";
import '../../assets/index40.css';const content = "_content_1sh7t_9";
const arrow = "_arrow_1sh7t_29";
const s = {
  content,
  "appear-animation": "_appear-animation_1sh7t_1",
  arrow
};
const TooltipContext = createContext({});
const TooltipTrigger = forwardRef(
  ({ children, asChild = true }, ref) => {
    const { setCustomTrigger } = useContext(TooltipContext);
    useLayoutEffect(() => {
      setCustomTrigger(true);
    }, []);
    return /* @__PURE__ */ jsx(RadixTooltip.Trigger, { asChild, ref, children });
  }
);
const TooltipComponent = ({
  children,
  content: content2,
  withoutArrow = true,
  providerProps = {},
  rootProps = {},
  contentProps = {},
  contentClassName,
  side,
  sideOffset = 4,
  align
}) => {
  const [isCustomTrigger, setIsCustomTrigger] = useState(false);
  const contextValue = useMemo(
    () => ({
      setCustomTrigger: (v) => setIsCustomTrigger(v)
    }),
    []
  );
  return /* @__PURE__ */ jsx(TooltipContext.Provider, { value: contextValue, children: /* @__PURE__ */ jsx(RadixTooltip.Provider, { delayDuration: 200, skipDelayDuration: 200, ...providerProps, children: /* @__PURE__ */ jsxs(RadixTooltip.Root, { ...rootProps, children: [
    isCustomTrigger ? children : /* @__PURE__ */ jsx(RadixTooltip.Trigger, { asChild: true, children }),
    content2 && /* @__PURE__ */ jsx(RadixTooltip.Portal, { container: document.getElementById(DEFAULT_PORTAL_ID), children: /* @__PURE__ */ jsxs(
      RadixTooltip.Content,
      {
        ...contentProps,
        side,
        sideOffset,
        align,
        className: clsx(s.content, contentClassName),
        children: [
          content2,
          !withoutArrow && /* @__PURE__ */ jsx(RadixTooltip.Arrow, { className: s.arrow })
        ]
      }
    ) })
  ] }) }) });
};
const Tooltip = Object.assign(TooltipComponent, {
  Trigger: TooltipTrigger,
  CONTENT_CLASS_NAME: s.content
});
export {
  Tooltip
};
